import { FormEvent, useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { RecompensaResposta } from "../../interfaces/recompensa"
import { listarRecompensas } from "../../services/recompensa"
import usuarioImg from "../../assets/img/usuario.png"
import visualizarIcon from '../../assets/img/visualizarIcon.png'
import Organizacao from "../../middleware/Organizacao"
import DivSituacao from "../DivSituacao"
import FiltrosDefault from "../FiltrosDefault"
import ModalDetalhesRecompensa from "../ModalDetalhesRecompensa"
import ModalRecompensa from "../ModalRecompensa/ModalRecompensa"
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato"
import Permissao from "../../middleware/Permissoes"
import "./index.css"

function Recompensas() {

    const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false)
    const [titulo, setTitulo] = useState("")
    const [situacao, setSituacao] = useState("")
    const [recompensas, setRecompensas] = useState<RecompensaResposta[]>([])
    const [recompensaSelecionado, setRecompensaSelecionado] = useState<RecompensaResposta>()

    const [pagina, setPagina] = useState(1)
    const [maisDados, setMaisDados] = useState(true)

    const scrollInfinito = async (e: React.UIEvent<HTMLElement>) => {

        const { scrollTop, clientHeight, scrollHeight } = e.target as HTMLElement

        const posicaoScroll = (scrollTop / (scrollHeight - clientHeight)) * 100

        if (posicaoScroll >= 90 && maisDados && !processando) {

            setProcessando(true)

            const novaPagina = pagina + 1

            try {
                const payload = {
                    titulo,
                    situacao,
                    pagina: novaPagina
                }

                const resposta = await listarRecompensas(payload)

                if (resposta.data.length === 10) {
                    setMaisDados(false)
                    return
                }

                setRecompensas(prev => [...prev, ...resposta.data])
                setPagina(novaPagina)

            } catch {
                toast.error("Erro ao buscar mais recompensas")
            } finally {
                setProcessando(false)
            }
        }
    }

    const abrirModalVisualizarRecompensa = (item: RecompensaResposta) => {
        setRecompensaSelecionado(item)
        modalExibir("ModalDetalhesRecompensa")
    }

    const abrirModalAtualizar = (item: RecompensaResposta) => {
        setRecompensaSelecionado(item)
        modalExibir("ModalAtualizarRecompensa")
    }

    const buscarRecompensas = async (e?: FormEvent) => {
        
        e?.preventDefault()

        setProcessando(true)
        setPagina(1)
        setMaisDados(true)

        try {
            const resposta = await listarRecompensas({
                titulo,
                situacao,
                pagina: 1
            })

            setRecompensas(resposta.data)

            if (resposta.data.length < 10) {
                setMaisDados(false)
            }

        } catch {
            toast.error("Erro ao listar Recompensas.")
        } finally {
            setProcessando(false)
        }
    }

    useEffect(() => {
        buscarRecompensas()
    }, [atualizarInformacoes])

    return (
        <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
            <Permissao permissoes={['master', 'conquistas_recompensa']}>
                <div id="paginaContainer">
                    {recompensaSelecionado && modal.nome === "ModalAtualizarRecompensa" && (
                        <ModalRecompensa recompensa={recompensaSelecionado} />
                    )}
                    {recompensaSelecionado && modal.nome === "ModalDetalhesRecompensa" && (
                        <ModalDetalhesRecompensa recompensa={recompensaSelecionado} />
                    )}
                    <FiltrosDefault
                        termo={titulo}
                        situacao={situacao}
                        placeholder="Pesquise pelo nome do Usuário"
                        tipo=""
                        onChangeTermo={(e) => setTitulo(e.target.value)}
                        onChangeSituacao={(e) => setSituacao(e.target.value)}
                        onSubmit={buscarRecompensas}
                        listaSituacao={[
                            { nome: "Todas", valor: "" },
                            { nome: "Em Análise", valor: "Em Análise" },
                            { nome: "Preparando", valor: "Preparando" },
                            { nome: "Conquistada", valor: "Conquistada" },
                            { nome: "Reprovada", valor: "Reprovada" },
                        ]}
                        genero="feminino"
                        maisFiltros={false}
                        acaoMaisFiltro={() => { }}
                        isLoading={processando}
                    />
                    {recompensas.length === 0 && <NenhumResultadoEncontrado />}
                    <section id="fundoContainerPagina" onScroll={scrollInfinito}>
                        <table id="tabelaListaContainer">
                            <thead>
                                <tr>
                                    <th id='ladoEsquerdoContent' align="left">Usuário</th>
                                    <th align="left">Conquista</th>
                                    <th align="left">Nível</th>
                                    <th align="left">Data</th>
                                    <th align="center">Situação</th>
                                    <th align="center">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    recompensas.map((recompensa) => (
                                        <tr key={recompensa.id}>
                                            <td className="primeiraColuna" onClick={() => abrirModalAtualizar(recompensa)}>
                                                <div className="linhaUsuarioImagem">
                                                    {recompensa?.usuario?.avatar ? <img className='usuarioResponsavel' src={recompensa?.usuario?.avatar} alt='' /> : <img className='usuarioResponsavel' src={usuarioImg} alt='' />}{recompensa.usuario.nome}
                                                </div>
                                            </td>
                                            <td align='left' onClick={() => abrirModalAtualizar(recompensa)}>{recompensa.descricaoConquista}</td>
                                            <td align='left' onClick={() => abrirModalAtualizar(recompensa)}>{recompensa.conquistaNivel.titulo}</td>
                                            <td align='left' onClick={() => abrirModalAtualizar(recompensa)}>{new Date(recompensa.criado).toLocaleDateString("pt-br")}</td>
                                            <td align="center">
                                                <DivSituacao
                                                    texto={`${recompensa.situacao.charAt(0).toUpperCase()}${recompensa.situacao.substring(1)}`}
                                                    cor={recompensa.situacao.toLowerCase()}
                                                />
                                            </td>
                                            <td id='ladoDireitoContent' align='center' onClick={() => abrirModalVisualizarRecompensa(recompensa)}>
                                                <img className='apagarIconeItemTabela' title='Visualizar Conquista' src={visualizarIcon} alt='' />
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </section>
                </div>
            </Permissao>
        </Organizacao>
    )
}

export default Recompensas
